<template>
  <main class="modal-main">
    <div class="prod-popup no-padding">
      <div class="step-padding">
        <div class='t_999 t_center fs-26'>第 3 步 (共 3 步)</div>
        <div class='t_title'>返回京东APP进行付款后，复制订单编号，回到此页面，点击提交订单</div>
        <div class='t_hlep no-border'>如有疑问，请点击 <span class='t_blue' @click="showCourse">常见问题</span></div>
      </div>
      <div class="step-padding mar-top">
        <div class='three-height' v-if="dataInfo">
          <div class='t_key space-between guide-coupon' v-if="dataInfo.IsCoupon">
            <div class='shrink t_999'>京东详情页领券：</div>
            <span class='coupon-tag-sure'>{{dataInfo.CouponAmount}}元券</span>
          </div>
          <div class="t_key space-between" v-if="dataInfo.FreightType">
            <div class="shrink t_999">运费（商品不包邮）：</div>
            <div class="flex">￥{{ dataInfo.Freight.toFixed(2) }}</div>
          </div>
          <div class='t_key space-between guide-price'>
            <div class='shrink t_999'>{{dataInfo.IsCoupon ? '券后付款金额' : '付款金额'}}：</div>
            <div class="flex-center">
              <div class='feeback-btn' @click="showDiff({taskID: taskID, dataInfo: dataInfo, platform: 1})">差价反馈</div>
              <div>￥{{dataInfo.ProductPrice.toFixed(2)}}</div>
            </div>
          </div>
          <div class='t_key space-between'>
            <div class='shrink t_999'>收货后返利：</div>
            <div class='flex'>￥{{dataInfo.BuyRebatePrice.toFixed(2)}}</div>
          </div>
          <div class="rist_tip" @click="riskDialogShow = true">垫付是否有风险？</div>
        </div>
        <div class='step_two'>
          <div class='step_img' @click='previewImg'><img :src='youpPath + step3Img' alt=""/></div>
        </div>
      </div>
    </div>
    <div class='tc_button'>
      <div class='tc_btn shPrimaryBtn' @click="entoOrderMerge">提交订单</div>
    </div>
    <preview-dialog
      v-if="previewDialogShow"
      @close="previewDialogShow = false"
      :img-src="youpPath + step3Img">
    </preview-dialog>
    <!-- 垫付保障弹窗 -->
    <risk-dialog
      v-if="riskDialogShow"
      :platform-type="1"
      @close="riskDialogShow = false">
    </risk-dialog>
  </main>
</template>

<script>
import feedbackBtnEvent from "@/mixins/feedbackBtnEvent";
import { IMG_BASE_URL } from '@/config'
import { Toast, Indicator } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import RiskDialog from '@/components/puppetComponent/RiskDialog'
import { OrderStep3InfoGet } from '@/api/detailPage'
export default {
  mixins: [feedbackBtnEvent],
  data () {
    return {
      youpPath: IMG_BASE_URL,
      step3Img: '/upaiyun/Sys/20211112/5421968345840466086.png',
      previewDialogShow: false,
      dataInfo: {},
      // 保障弹窗
      riskDialogShow: false
    }
  },
  components: {
    PreviewDialog,
    RiskDialog
  },
  created () {
    this.taskID = this.$route.query.readyTaskId
  },
  mounted () {
    if (this.taskID) {
      this.fetchData()
    } else {
      Toast('无任务id')
      this.$router.go(-1)
    }
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      OrderStep3InfoGet({ taskId: this.taskID }).then(res => {
        this.dataInfo = res.Data
        Indicator.close()
      }).catch((res) => {
        Indicator.close()
        if (res.ErrMsg) {
          Toast(res.ErrMsg)
        }
      })
    },
    // 预览
    previewImg () {
      this.previewDialogShow = true
    },
    // 查看教程
    showCourse () {
      this.$router.push({
        name: 'courseStep',
        query: {
          indexStep: 3,
          platform: 2
        }
      })
    },
    // 差价反馈
    diffPriceFeedback () {
      this.$router.push({
        name: 'diffPeiceFeedback',
        query: {
          taskID: this.taskID,
          platform: 1
        }
      })
    },
    // 步骤三 提交订单 跳转页面
    entoOrderMerge () {
      this.$router.push({
        name: 'orderSubmit',
        query: {
          taskID: this.taskID
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    let routeNames = ['jdStepOne', 'jdStepTwo', 'courseStep', 'diffPeiceFeedback', 'jdQuestionThree', 'order', 'checkPeiceFeedback']
    if (routeNames.indexOf(from.name) !== -1) {
      next()
    } else {
      next({ name: 'souhuo' })
    }
  }
}
</script>

<style scoped>
  @import '../../step.scss';
  .three-height{
    min-height: auto;
  }
  .coupon{
    height: 35px;
    padding-bottom: 2%;
    border-bottom: 1px solid #eee;
  }
  .rist_tip{
    width: 100%;
    text-align: right;
    color: #3399ff;
    cursor: pointer;
    padding-top: 5px;
  }
  .mar-top{
    margin-top: 1vh;
    padding-top: 0;
  }
  .flex-center{
    display: flex;
    align-items: center;
  }
  .t_key{
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    font-size: 14px;
  }
  .feeback-btn{
    background: #409EFf;
    color: #fff;
    height: 24px;
    line-height: 24px;
    border-radius: 15px;
    padding: 0 8px;
    box-sizing: border-box;
    margin-right: 5px;
  }
</style>
